const COUNT_API_BASE = 'https://countapi.mileshilliard.com/api/v1';

const SESSION_KEYS = {
  daily: 'inmotion-counted-daily',
  weekly: 'inmotion-counted-weekly',
  monthly: 'inmotion-counted-monthly',
};

function pad2(value) {
  return String(value).padStart(2, '0');
}

function getISOWeekInfo(date) {
  const normalized = new Date(date.getTime());
  normalized.setHours(0, 0, 0, 0);
  normalized.setDate(normalized.getDate() + 4 - (normalized.getDay() || 7));
  const isoYear = normalized.getFullYear();
  const yearStart = new Date(isoYear, 0, 1);
  const isoWeek = Math.ceil(((normalized - yearStart) / 86400000 + 1) / 7);

  return { isoYear, isoWeek };
}

export function getVisitorPeriodKeys(date = new Date()) {
  const year = date.getFullYear();
  const month = pad2(date.getMonth() + 1);
  const day = pad2(date.getDate());
  const { isoYear, isoWeek } = getISOWeekInfo(date);

  return {
    daily: `inmotion-daily-${year}-${month}-${day}`,
    weekly: `inmotion-weekly-${isoYear}-W${pad2(isoWeek)}`,
    monthly: `inmotion-monthly-${year}-${month}`,
    dailyId: `${year}-${month}-${day}`,
    weeklyId: `${isoYear}-W${pad2(isoWeek)}`,
    monthlyId: `${year}-${month}`,
  };
}

async function fetchCount(action, apiKey) {
  const response = await fetch(`${COUNT_API_BASE}/${action}/${apiKey}`);

  if (!response.ok) {
    throw new Error('Could not load visitor count');
  }

  const data = await response.json();

  if (typeof data.value !== 'number') {
    throw new Error('Could not load visitor count');
  }

  return data.value;
}

async function recordPeriodVisit(period, periodId, apiKey) {
  const storageKey = SESSION_KEYS[period];
  const alreadyCounted = sessionStorage.getItem(storageKey) === periodId;
  const action = alreadyCounted ? 'get' : 'hit';
  const value = await fetchCount(action, apiKey);

  if (!alreadyCounted) {
    sessionStorage.setItem(storageKey, periodId);
  }

  return value;
}

export async function recordVisitAndGetStats() {
  const keys = getVisitorPeriodKeys();

  const [daily, weekly, monthly] = await Promise.all([
    recordPeriodVisit('daily', keys.dailyId, keys.daily),
    recordPeriodVisit('weekly', keys.weeklyId, keys.weekly),
    recordPeriodVisit('monthly', keys.monthlyId, keys.monthly),
  ]);

  return { daily, weekly, monthly };
}
